import request from '@/utils/request'

export function cancelDisposed (disposed) {
  const method = 'post'
  const url = `/disposed/cancel/${disposed.id}`
  return request({
    url,
    method,
    data: {
      status_requested_date: disposed?.status_requested_date,
      status_documented_date: disposed?.status_documented_date,
    }
  })
}

// la lista delle request e' una custom API perche'
// mi serve anche la lista delle drugs
export function getDisposedList (filters, pagination) {
  const method = 'get'
  const url = '/disposed/list'

  //issue 316 - modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 316 - modifica date da-a

  return request({
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    },
    url, method
  })
}


export function validateDisposed(disposed) {
  const method = 'post'
  const url = `/disposed/validate/${disposed.id}`
  return request({
    url,
    method,
    data: {
      status_requested_date: disposed?.status_requested_date,
      status_documented_date: disposed?.status_documented_date,
    },
  })  
}

export function requestDisposed (id, data) {
  const method = 'post'
  const url = `/disposed/request/${id}`
  return request({
    url,
    method,
    data
  })
}

export function drugDisposableonStorage ({search, protocol_id, drug_id, storage_id, destroy_expired}) {
  const method = 'get'
  let url = ''
  if (drug_id) {
    url = `/disposed/druglot_disposable/${protocol_id}/${storage_id}/${drug_id}/`
  } else {
    url = `/disposed/drug_disposable/${protocol_id}/${storage_id}/`
  }
  if (search) {
    url += encodeURI(search)
  }
  return request({
    url,
    method,
    params: { destroy_expired }
  })
}

export function drugDisposableReturned ({search, protocol_id, disposal_id, drug_id}) {
  const method = 'get'
  let url = ''
  if (drug_id) {
    url = `/disposed/druglot_returned/${protocol_id}/${disposal_id}/${drug_id}/`
  } else {
    url = `/disposed/drug_returned/${protocol_id}/${disposal_id}/`
  }
  if (search) {
    url += encodeURI(search)
  }
  return request({
    url,
    method
  })
}

export function siteDrugDisposable ({search, protocol_id, site_id, drug_id, destroy_expired}) {
  const method = 'get'
  let url =''
  if (drug_id) {
    url = `/disposed/sitedruglot_disposable/${protocol_id}/${site_id}/${drug_id}/`
  } else {
    url = `/disposed/sitedrug_disposable/${protocol_id}/${site_id}/`
  }
  if (search) {
    url += encodeURI(search)
  }
  return request({
    url,
    method,
    params: { destroy_expired }
  })
}
